"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverLicenseStatusTypes = void 0;
var DriverLicenseStatusTypes;
(function (DriverLicenseStatusTypes) {
    DriverLicenseStatusTypes["VALID_US_LICENSE"] = "ValidUSLicense";
    DriverLicenseStatusTypes["PERMIT"] = "Permit";
    DriverLicenseStatusTypes["SUSPENDED"] = "Suspended";
    DriverLicenseStatusTypes["RESTRICTED"] = "Restricted";
    DriverLicenseStatusTypes["PERMANENTLY_REVOKED"] = "PermanentlyRevoked";
    DriverLicenseStatusTypes["EXPIRED"] = "Expired";
    DriverLicenseStatusTypes["SURRENDERED"] = "Surrendered";
    DriverLicenseStatusTypes["NON_LICENSED"] = "NonLicensed";
})(DriverLicenseStatusTypes = exports.DriverLicenseStatusTypes || (exports.DriverLicenseStatusTypes = {}));
